import React, {useState, useEffect, useContext, useRef} from 'react'
import {withRouter, Link} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
import {Map, GoogleApiWrapper, Marker} from 'google-maps-react'
import swal from 'sweetalert'
import Spinner from './Spinner'

import {ContextApp} from '../context/ContextApp'
import ModalBuyByCard from './ModalBuyByCard'

const mapStyles = {
  width: '100%',
  height: '100%',
}

const Checkout = props => {
  const [item, setItem] = useState(10)

  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)

  const {history} = props

  const contextApp = useContext(ContextApp)
  const {
    paymentWithCreditCard,
    cleanIdAddressGenerated,
    idAddressGenerated,
    userAddress,
    getMunicipalities,
    saveAddresses,
    deparments,
    carShopping,
    user,
    setCategoryShowClose,
    redirectSuccess,
    deliveryInfo,
    createOrderFinally,
    cleanDeliveryInfo,
    cancelSpinner
  } = contextApp

  const [cardInfo, setCardInfo] = useState({
    cardName: '',
    cardNumber: '',
    cvv_card: '',
    expiration_card_year: '',
    expiration_month: '',
  })

  useEffect(() => {
    setCategoryShowClose()
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setLatitude(position.coords.latitude)
        setLongitude(position.coords.longitude)
      },
      function (error) {
        console.error('Error Code = ' + error.code + ' - ' + error.message)
      },
    )

    if (redirectSuccess == true) {
      setShowModalToCardPay(false)
      history.push('/success')
    }

    if (deliveryInfo.length !== 0) {
      setShowSpinner(false)
    }
  }, [redirectSuccess, deliveryInfo])

  const onMarkerClick = e => {
    //console.log("marker clicked");
  }

  //   cart.forEach(function(obj) {
  //     var key = JSON.stringify(obj)
  //     counter[key] = (counter[key] || 0) + 1

  // })

  // console.log(cart, total,items,  'check')

  console.log(deliveryInfo)

  const [municipalitiesState, setMunicipalitiesState] = useState(null)
  const [direction, setDirection] = useState({
    name: '',
    description: '',
    location: '',
    notes: '',
    city_id: 0,
    municipality_id: 0,
  })

  const [coupon, setCoupon] = useState({
    code: '',
    coupon_id: 0,
    discount: 0.0,
  })

  const {city_id} = direction
  let shipping = 0

  if (city_id == 6) {
    shipping += 3.5
    //console.log('waka waka');
  } else {
    shipping += 3.99
  }

  const handleDeparment = e => {
    cleanDeliveryInfo()
    //console.log(e.target.value)
    const municipalities = getMunicipalities(e.target.value)
    setMunicipalitiesState(municipalities)
    setDirection({
      ...direction,
      city_id: +e.target.value,
      municipality_id: 0,
    })
  }

  const handleMunici = e => {
    cleanDeliveryInfo()

    setDirection({
      ...direction,
      municipality_id: +e.target.value,
    })
  }

  const handleInputsText = e => {
    setDirection({
      ...direction,
      [e.target.name]: e.target.value,
    })
  }

  const handleInputCouponText = e => {
    setCoupon({
      ...coupon,
      code: e.target.value,
    })
  }

  const [showDiv, setShowDiv] = useState(false)

  const direcciones = userAddress

  const [selecTipoDireccion, setSelecTipoDireccion] = useState('nueva')
  const [idAddress, setIdAddress] = useState(-99)

  let {name, description, municipality_id} = direction

  const handleDireciones = e => {
    cleanDeliveryInfo()

    //console.log("mostrar seleccion de direccione")
    //console.log(e.target.value)

    if (e.target.value == '0') {
      setDirection({
        ...direction,
        name: '',
        description: '',
        location: '',
        notes: '',
        city_id: 0,
        municipality_id: 0,
      })

      cleanDeliveryInfo()
      cleanIdAddressGenerated()
      setIdAddress(-99)
      setSelecTipoDireccion('nueva')

      //console.log("No selecciono nada, direccion actual")
      //console.log(direction)
    } else {
      if (e.target.value == 'nueva') {
        setShowDiv(true)
        setSelecTipoDireccion('nueva')
        setIdAddress(-99)

        //console.log("Es nueva direcc")
      } else {
        setShowDiv(false)
        setSelecTipoDireccion('antigua')
        setIdAddress(e.target.value)
        //console.log("Es antigua direcc")
      }
    }
  }

  const [methodPayment, setMethodPayment] = useState(null)

  const handleSubmit = e => {
    e.preventDefault()
    setDirection({
      ...direction,
      location: `${latitude}, ${longitude}`,
    })

    //console.log("Validando direccion a enviar en el submit")
    //console.log(selecTipoDireccion)

    if (selecTipoDireccion == 'nueva') {
      //console.log("validando nueva direccion a enviar")

      if (
        name == '' ||
        city_id == 0 ||
        municipality_id == 0 ||
        description == ''
      ) {
        swal(
          'Por favor, llena todos los campos para poder procesar tu orden',
          '',
          'info',
        )
        return
      }
    }

    //console.log("-------> idAddressGenerated {"+idAddressGenerated+"}  idAddress {" +idAddress+"} <--------- " )

    if (idAddressGenerated == 0 && (idAddress == -99 || idAddress == 0)) {
      //console.log("Nueva direccion")
      if (
        name == '' ||
        city_id == 0 ||
        municipality_id == 0 ||
        description == ''
      ) {
        swal(
          'Por favor, llena todos los campos para poder procesar tu orden',
          '',
          'info',
        )
        return
      } else {
        setShowSpinner(true)
        if (methodPayment == 'Tarjeta') {
          saveAddresses(direction, methodPayment, coupon, idAddress, cardInfo)
        } else {
          saveAddresses(direction, methodPayment, coupon, idAddress, cardInfo)
        }
      }
    } else {
      //console.log("Con Id de direccion creada o seleccionada")

      if (idAddressGenerated == 0) {
        setShowSpinner(true)
        if (methodPayment == 'Tarjeta') {
          saveAddresses(direction, methodPayment, coupon, idAddress, cardInfo)
        } else {
          saveAddresses(direction, methodPayment, coupon, idAddress, cardInfo)
        }
      } else {
        setShowSpinner(true)
        //saveAddresses(direction, methodPayment, coupon,idAddressGenerated)
        if (methodPayment == 'Tarjeta') {
          saveAddresses(
            direction,
            methodPayment,
            coupon,
            idAddressGenerated,
            cardInfo,
          )
        } else {
          saveAddresses(
            direction,
            methodPayment,
            coupon,
            idAddressGenerated,
            cardInfo,
          )
        }
      }
    }
  }

  const totalArray = carShopping.map(product => {
    let costProduct = product.batches[0].unit_price
    return costProduct
  })

  let suma = 0
  totalArray.forEach(function (numero) {
    suma += numero
  })

  const providers_id = carShopping.map(product => {
    let id = product.provider_id
    return id
  })

  var uniqs = providers_id.filter(function (item, index, array) {
    return array.indexOf(item) === index
  })

  const mulplicate = uniqs.length

  let totalDeEnvio = 0
  for (let x = 0; x < deliveryInfo.length; x++) {
    totalDeEnvio += deliveryInfo[x].delivery
  }
  let subTotal = 0
  for (let x = 0; x < deliveryInfo.length; x++) {
    subTotal += deliveryInfo[x].total
  }

  let totalToPayBuyer = 0
  let totalCreditFee = 0
  for (let x = 0; x < deliveryInfo.length; x++) {
    totalToPayBuyer += deliveryInfo[x].total
    totalCreditFee += deliveryInfo[x].credit_fee
  }

  const [showModalToCardPay, setShowModalToCardPay] = useState(false)
  const [optionCard, setOptionCard] = useState(false)

  const [classNone, setClassNone] = useState('')
  const [activeForm, setActiveForm] = useState('false')

  const hanldeGoToPay = () => {
    if (optionCard) {
      //setShowModalToCardPay(true)

      paymentWithCreditCard(cardInfo, coupon)
      return
    } else {
      setClassNone('none-display')
      setShowSpinner(true)
      createOrderFinally(coupon)
      return
    }
  }

  const [showSpinner, setShowSpinner] = useState(false)

  //let state = {showDiv: true};
  //const {showDiv}= state;
  //const [showDiv, setShowDiv] = useState(false)

  const handleInput = e => {
    setCardInfo({
      ...cardInfo,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmitCard = e => {
    e.preventDefault()
    setShowSpinner(true)
    paymentWithCreditCard(cardInfo, coupon)
  }

  const [disbaleGenerateBuy, setDisableGenerateBuy] = useState(false)
  const [disbaleGenerateBuyAction, setDisableGenerateBuyAction] = useState(false)
  const scrollTop = useRef(null)
  const scrollToBottom = () => {
    scrollTop.current.scrollIntoView({ behavior: "smooth" })
    setDisableGenerateBuy(true)
  }

  useEffect(() => {
    if(disbaleGenerateBuy) {
      setTimeout(() => {
        setDisableGenerateBuyAction(true)
        
      }, 1000);
    }
  }, [disbaleGenerateBuy])

  const [showLoading, setShowLoading] = useState(false)
  useEffect(() => {
    if(disbaleGenerateBuyAction) {
      setShowLoading(true)
    }
  }, [disbaleGenerateBuyAction])

  useEffect(() => {
    if(deliveryInfo.length !== 0) {
      setShowLoading(false)
    }
  }, [deliveryInfo])

  useEffect(() => {
    if(showLoading) {
      setTimeout(() => {
        setShowLoading(false)
      }, 4000);
    }
  }, [showLoading])

  return (
    <>
      {showModalToCardPay == true &&
      deliveryInfo.length !== 0 &&
      optionCard == true ? (
        <ModalBuyByCard
          totalToPayBuyer={totalToPayBuyer}
          showModalToCardPay={showModalToCardPay}
          setShowModalToCardPay={setShowModalToCardPay}
        />
      ) : null}
      {showLoading && (
        <div className="loading-information-wait">
          <Spinner />
        </div>
      )}

      <div id="page" className="hfeed site">
      <div ref={scrollTop} />
        <a className="skip-link screen-reader-text" href="#site-navigation">
          Skip to navigation
        </a>
        <a className="skip-link screen-reader-text" href="#content">
          {item}
        </a>
        <div id="content" className="site-content" tabIndex={-1}>
          <div className="container">
            <nav className="woocommerce-breadcrumb">
              <span className="delimiter"></span>
            </nav>
            <div id="primary" className="content-area">
              <main id="main" className="site-main">
                <article className="page type-page status-publish hentry">
                  <header className="entry-header">
                    <h1 itemProp="name" className="entry-title">
                      Checkout
                    </h1>
                  </header>
                  {/* .entry-header */}
                  <form
                    encType="multipart/form-data"
                    className="checkout woocommerce-checkout"
                    onSubmit={e => handleSubmit(e)}
                    name="checkout"
                  >
                    {Object.keys(user).length === 0 ? (
                      <div className="checkout-ads">
                        <h2 style={{color: 'white'}}>
                          Debes estar logueado para terminar de procesar tu
                          compra
                        </h2>
                        <Link to={'/my_account'} className="login_btn_go_to">
                          Ingresa a tu cuenta &rarr;
                        </Link>
                      </div>
                    ) : (
                      <div class="row">
                        <div className="col-lg-7 order-lg-1">
                          <div
                            className="woocommerce-billing-fields"
                            style={{
                              fontSize: '1.2em',
                              //  fontFamily:'Roboto',
                              lineHeight: '1.286em',
                              fontWeight: '700',
                            }}
                          >
                            <h3>Detalles de la facturación</h3>
                            <div className="js-form-message mb-12">
                              <label className="form-label">
                                Nombre{' '}
                                <abbr
                                  title="required"
                                  className="required"
                                ></abbr>
                              </label>
                              <span> {user.user.name}</span>
                            </div>
                            <div className="js-form-message mb-12">
                              <label className="form-label">
                                País/Región{' '}
                                <abbr
                                  title="required"
                                  className="required"
                                ></abbr>
                              </label>
                              <span>El salvador</span>
                            </div>

                            <form>
                              <div className="js-form-message mb-12">
                                <label className="form-label">
                                  Establecer dirección de entrega
                                  <span className="text-danger"> * </span>
                                  <abbr
                                    title="required"
                                    className="required"
                                  ></abbr>
                                </label>
                                <select
                                  name=""
                                  id=""
                                  onChange={e => handleDireciones(e)}
                                  className="form-control"
                                  data-live-search="true"
                                  data-style="form-control border-color-1 font-weight-normal"
                                >
                                  <option value="0">
                                    Seleciona una dirección
                                  </option>
                                  <option value="nueva">
                                    Agregar una nueva
                                  </option>
                                  {direcciones?.map(dir => (
                                    <option value={dir.id}>
                                      {dir.name} - {dir.description}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="js-form-message mb-12">
                                <label>
                                  <span style={{color: 'Red'}}>NOTA: </span>Las
                                  entregas que corresponden a caseríos, cantones
                                  y zonas de alto riesgo, podrían ser afectados
                                  en los tiempos de entrega.
                                </label>
                              </div>

                              {showDiv ? (
                                <div>
                                  <div className="js-form-message mb-12">
                                    <label className="form-label" for="name">
                                      Nombre De Dirección
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Mi Casa / Oficina / Direccion1 "
                                      name="name"
                                      className="form-control"
                                      aria-label="Company Name"
                                      onChange={e => handleInputsText(e)}
                                      required
                                    />
                                  </div>
                                  <div className="js-form-message mb-12">
                                    <label className="form-label" for="name">
                                      Detalle De Dirección
                                      <span class="text-danger">*</span>
                                    </label>
                                    <textarea
                                      onChange={handleInputsText}
                                      name="description"
                                      className="form-control p-5"
                                      id="description"
                                      placeholder="Dirección detallada"
                                      rows="2"
                                      cols="5"
                                      required
                                    />
                                  </div>
                                  <div className="js-form-message mb-6">
                                    <label className="form-label" for="name">
                                      Departamento
                                      <span class="text-danger">*</span>
                                    </label>
                                    <select
                                      name=""
                                      id=""
                                      onChange={e => handleDeparment(e)}
                                      required
                                      className="form-control"
                                      data-live-search="true"
                                      data-style="form-control border-color-1 font-weight-normal"
                                    >
                                      <option value="0">
                                        Seleciona un departamento
                                      </option>
                                      {deparments.map(deparment => (
                                        <option value={deparment.id}>
                                          {deparment.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  {municipalitiesState == null ? null : (
                                    <div className="js-form-message mb-6">
                                      <label className="form-label" for="name">
                                        Municipio
                                        <span class="text-danger">*</span>
                                      </label>
                                      <select
                                        required
                                        className="form-control"
                                        data-live-search="true"
                                        data-style="form-control border-color-1 font-weight-normal"
                                        onChange={e => handleMunici(e)}
                                      >
                                        <option value="">
                                          Seleciona un Municipio
                                        </option>
                                        {municipalitiesState.map(munici => (
                                          <option value={munici.id}>
                                            {munici.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </form>

                            <div className="js-form-message mb-12">
                              <label className="form-label" htmlFor="coupon">
                                ¿Quiéres usar un cupón?
                              </label>
                              <input
                                onChange={handleInputCouponText}
                                type="text"
                                id="coupon"
                                name="coupon"
                                className="form-control"
                              />
                            </div>

                            <div class="border-bottom border-color-1 mb-5">
                              <h3 class="section-title mb-0 pb-2 font-size-25">
                                Información adicional
                              </h3>
                            </div>

                            <div className="js-form-message mb-12">
                              <label
                                for="order_comments"
                                className="form-label"
                              >
                                Notas del pedido&nbsp;
                                <span class="optional">(opcional)</span>
                              </label>
                              <textarea
                                onChange={handleInputsText}
                                name="notes"
                                className="form-control p-5"
                                id="order_comments"
                                placeholder="Notas sobre tu pedido, por ejemplo, notas especiales para la entrega."
                                rows="2"
                                cols="5"
                              ></textarea>
                            </div>

                            <div class="border-bottom border-color-1 mb-5">
                              <h3 class="section-title mb-0 pb-2 font-size-25">
                                Información de Pago
                              </h3>
                            </div>
                            <div
                              className="woocommerce-checkout-payment"
                              id="payment"
                            >
                              <ul className="wc_payment_methods payment_methods methods">
                                <li
                                  className="wc_payment_method payment_method_bacs"
                                  onClick={() => {
                                    setOptionCard(true)
                                    setMethodPayment('Tarjeta')
                                    setActiveForm(true)
                                  }}
                                >
                                  <input
                                    type="radio"
                                    data-order_button_text
                                    defaultValue="bacs"
                                    name="payment_method"
                                    className="input-radio"
                                    id="payment_method_bacs"
                                  />
                                  <label htmlFor="payment_method_bacs">
                                    Pago con Tarjeta de Crédito
                                  </label>
                                  {/* <div className="payment_box payment_method_bacs">
                                                <p>
                                                  Realice su pago directamente usando nuestra
                                                  plataforma. Utilice su ID de pedido como
                                                  referencia de pago. Su pedido no se enviará
                                                  hasta que los fondos se hayan liquidado en
                                                  nuestra cuenta.
                                                </p>
                                              </div>  */}
                                </li>

                                <li
                                  className="wc_payment_method payment_method_cod"
                                  onClick={() => {
                                    setShowModalToCardPay(false)
                                    setOptionCard(false)
                                    setMethodPayment('Efectivo')
                                    setActiveForm(false)
                                  }}
                                >
                                  <input
                                    type="radio"
                                    data-order_button_text
                                    defaultValue="cod"
                                    name="payment_method"
                                    className="input-radio"
                                    id="payment_method_cod"
                                    required
                                  />
                                  <label htmlFor="payment_method_cod">
                                    Efectivo contra entrega
                                  </label>
                                  <div
                                    style={{display: 'none'}}
                                    className="payment_box payment_method_cod"
                                  >
                                    <p>Pay with cash upon delivery.</p>
                                  </div>
                                </li>
                              </ul>

                              {activeForm == true ? (
                                <form
                                  className={classNone}
                                  onSubmit={e => handleSubmitCard(e)}
                                >
                                  <div class="border-bottom border-color-1 mb-12">
                                    <h3 class="section-title mb-0 pb-2 font-size-25">
                                      Información de Tarjeta
                                    </h3>
                                  </div>
                                  <div className="js-form-message mb-12">
                                    <label htmlFor="" className="form-label">
                                      Nombre
                                    </label>
                                    <input
                                      class="form-control"
                                      type="text"
                                      name="cardName"
                                      id=""
                                      placeholder="Nombre del titular"
                                      required="true"
                                      onChange={e => handleInput(e)}
                                      required="true"
                                    />
                                  </div>
                                  <div className="js-form-message mb-6">
                                    <label htmlFor="" className="form-label">
                                      DUI
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="cardNumber"
                                      id=""
                                      placeholder="DUI"
                                      required="true"
                                      defaultValue={user.user.dui}
                                    />
                                  </div>
                                  <div className="js-form-message mb-6">
                                    <label htmlFor="" className="form-label">
                                      Numero de tarjeta
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="cardNumber"
                                      id=""
                                      placeholder="9999994570392223"
                                      onChange={e => handleInput(e)}
                                      required="true"
                                    />
                                  </div>
                                  <div className="js-form-message mb-6">
                                    <div className="js-form-message mb-6">
                                      <label htmlFor="" className="form-label">
                                        Año
                                      </label>
                                      <select
                                        name="expiration_card_year"
                                        id=""
                                        onChange={e => handleInput(e)}
                                      >
                                        <option value="30">30</option>
                                        <option value="29">29</option>
                                        <option value="28">28</option>
                                        <option value="27">27</option>
                                        <option value="26">26</option>
                                        <option value="25">25</option>
                                        <option value="24">24</option>
                                        <option value="23">23</option>
                                        <option value="22">22</option>
                                        <option value="21">21</option>
                                        <option value="20">20</option>
                                      </select>

                                      {/* <input type="text" name="expiration_card_year" id="" placeholder="20"
                                        onChange={e => handleInput(e)}
                                        required="true"
                                    />
                                    <small class="form-text text-muted">Únicamente los últimos 2 dígitos.</small> */}
                                    </div>
                                    <div className="js-form-message mb-6">
                                      <label htmlFor="" className="form-label">
                                        Mes
                                      </label>
                                      <select
                                        name="expiration_month"
                                        id=""
                                        onChange={e => handleInput(e)}
                                      >
                                        <option value="01">01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                      </select>
                                      {/* <input type="text" name="expiration_month" id="" placeholder="08"
                                        onChange={e => handleInput(e)}  
                                        required="true"                                      
                                    /> */}
                                    </div>
                                  </div>

                                  <div className="js-form-message mb-6">
                                    <label htmlFor="" className="form-label">
                                      CVC
                                    </label>
                                    <input
                                      type="text"
                                      name="cvv_card"
                                      id=""
                                      placeholder="123"
                                      onChange={e => handleInput(e)}
                                      required="true"
                                    />
                                    <small class="form-text text-muted">
                                      Únicamente los 3 dígitos.
                                    </small>
                                  </div>

                                  {showSpinner ? (
                                    <div className="spinner-modal">
                                      <div class="lds-ring">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                      </div>
                                    </div>
                                  ) : null}
                                </form>
                              ) : null}
                              <div className="form-row place-order">
                                {/* <p className="form-row terms wc-terms-and-conditions">
                                        <input
                                          type="checkbox"
                                          id="terms"
                                          name="terms"
                                          className="input-checkbox"
                                          required
                                        />
                                        <label className="checkbox" htmlFor="terms">
                                          Acepto los{" "}
                                          <a href="#">terminos &amp; condiciones</a>{" "}
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="hidden"
                                          defaultValue={1}
                                          name="terms-field"
                                        />
                                      </p> */}

                                {deliveryInfo.length === 0 ? (
                                  <>
                                    <input
                                      type="submit"
                                      value="Generar total de compra"
                                      data-value="Place order"
                                      defaultValue="Place order"
                                      className="button alt"
                                      disabled={disbaleGenerateBuyAction}
                                      style={{color: 'white'}}
                                      onClick={() => scrollToBottom()}
                                    />
                                  </>
                                ) : (
                                  <>
                                    <button
                                      className={`button alt ${classNone}`}
                                      onClick={() => {
                                        setShowLoading(true)
                                        hanldeGoToPay()
                                      }}
                                    >
                                      {methodPayment == 'Efectivo'
                                        ? 'Procesar Pedido'
                                        : 'Pagar Pedido'}
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-5 order-lg-2 mb-7 mb-lg-0">
                          <div class="pl-lg-3 ">
                            <div class="bg-gray-1 rounded-lg">
                              <div class="p-4 mb-4 checkout-table">
                                <div class="border-bottom border-color-1 mb-5">
                                  <h3 class="section-title mb-0 pb-2 font-size-25">
                                    Orden
                                  </h3>
                                  <label style={{marginTop: '1rem'}}>
                                    <span style={{color: 'Red'}}>
                                      Importante:{' '}
                                    </span>
                                    Todas las compras realizadas los días
                                    sábados y domingos, iniciarán su proceso de
                                    recolección y entrega a partir del día
                                    lunes.
                                  </label>
                                </div>

                                <table className="table">
                                  {deliveryInfo.length === 0 ? (
                                    <thead>
                                      <tr>
                                        <th className="product-name">
                                          Ingresa los datos de dirección de
                                          entrega para completar tu orden.
                                        </th>
                                        <th className="product-total"></th>
                                      </tr>
                                    </thead>
                                  ) : (
                                    <thead>
                                      <tr>
                                        <th className="product-name">
                                          Detalles de orden
                                        </th>
                                        <th className="product-total"></th>
                                      </tr>
                                    </thead>
                                  )}

                                  {deliveryInfo === 0 ? null : (
                                    <tbody>
                                      {deliveryInfo.map(
                                        (delivery, index, array) => {
                                          //console.log(index)
                                          //console.log(array)
                                          return (
                                            <>
                                              <tr className="provider-info-payment">
                                                <th>
                                                  <span>Proveedor: </span>
                                                  {delivery.provider.name}
                                                </th>
                                                <th>
                                                  <span>Municipio: </span>
                                                  {
                                                    delivery.provider
                                                      .municipality.name
                                                  }
                                                </th>
                                              </tr>
                                              {array[index].items.map(
                                                product => (
                                                  <tr>
                                                    <th>
                                                      {product.name} x{' '}
                                                      {product.quantity}
                                                    </th>
                                                    <th>
                                                      $ {product.unit_price * product.quantity}
                                                    </th>
                                                  </tr>
                                                ),
                                              )}
                                              <tr>
                                                <th>SUBTOTAL</th>
                                                <th>$ {delivery.subtotal}</th>
                                              </tr>
                                              <tr>
                                                <th>TARIFA DE ENVÍO</th>
                                                <th>$ {delivery.delivery}</th>
                                              </tr>
                                              <tr>
                                                <th>DESCUENTO</th>
                                                <th>
                                                  ${' '}
                                                  {delivery.discount_purcharse}
                                                </th>
                                              </tr>
                                              <tr>
                                                <th>
                                                  TOTAL DE{' '}
                                                  {delivery.provider.name}
                                                </th>
                                                <th>
                                                  ${' '}
                                                  {delivery.total_delivery.toFixed(
                                                    2,
                                                  )}
                                                </th>
                                              </tr>
                                            </>
                                          )
                                        },
                                      )}
                                    </tbody>
                                  )}

                                  <tfoot style={{marginTop: '1rem'}}>
                                    {deliveryInfo.length === 0 ? null : (
                                      <>
                                        <tr className="">
                                          <th>Booking fee</th>
                                          <td>
                                            <strong>
                                              <span className="amount">
                                                $
                                                {parseFloat(
                                                  totalCreditFee,
                                                ).toFixed(2)}
                                              </span>
                                            </strong>
                                          </td>
                                        </tr>

                                        <tr className="order-total">
                                          <th>TOTAL DE COMPRA</th>
                                          <td>
                                            <strong>
                                              <span className="amount">
                                                $
                                                {parseFloat(
                                                  totalToPayBuyer,
                                                ).toFixed(2)}
                                              </span>
                                            </strong>
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                  </tfoot>
                                </table>

                                <div
                                  style={{
                                    fontSize: '1.2em',
                                    lineHeight: '1.286em',
                                    fontWeight: '700',
                                  }}
                                  className="woocommerce-checkout-review-order"
                                  id="order_review"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </form>
                </article>
              </main>
              {/* #main */}
            </div>
            {/* #primary */}
          </div>
          {/* .container */}
        </div>
        {/* #content */}
        <section className="brands-carousel"></section>
      </div>
    </>
  )
}

export default withRouter(
  GoogleApiWrapper({
    apiKey: 'AIzaSyC4gkylQtFlBJbei5HLckfvnJeO1km3wm4',
  })(Checkout),
)
